import { JSONRecord } from '../json';
import { isString } from '../../helper/string';

export type SafeNetworksStore = {
  featureEnabled: boolean;
  validSafeNetworks: SafeNetworkConfig[];
  activeSafeNetwork?: ActiveSafeNetwork;
  probeRetries: number;
  nextUpdateTimestamp: number;
};

export type SafeNetworkConfig = {
  url: string;
  expectedStatusCode: number;
  expectedContentMatch: JSONRecord[];
};

export type ActiveSafeNetwork = {
  url: string;
  response?: JSONRecord;
};

/**
 * Returns the organisation name of the Safe Network
 *
 * Returns undefined if the name is missing, invalid or empty/blank.
 */
export const getOrganisationName = (
  safeNetwork?: ActiveSafeNetwork
): string | undefined => {
  const name = safeNetwork?.response?.organisation_name;
  if (name && isString(name) && (name as string).trim() !== '') {
    return name as string;
  }
  return undefined;
};
